import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import StudentPracticeSessionResult from '@ts-core/modules/practice/components/StudentPracticeSessionResult';
import BackButton from '@ts-core/components/BackButton';

import { usePracticeSessionDetails } from '../../hooks';

const PracticeSessionDetailsPage = () => {
  const history = useHistory();
  const { courseId, practiceSessionId } = useParams<{ courseId: string; practiceSessionId: string }>();

  const { practiceSession, loading } = usePracticeSessionDetails({
    courseId,
    practiceSessionId,
  });

  const onGoBack = useCallback(() => {
    history.push(`/${courseId}/practice`);
  }, [history, courseId]);

  return (
    <>
      <BackButton onGoBack={onGoBack} subtitle={<FormattedMessage id="practiceSessions.title" />} />
      <StudentPracticeSessionResult practiceSession={practiceSession} loading={loading} />
    </>
  );
};

export default PracticeSessionDetailsPage;
